import { gql } from '../types/generated';

export const GET_PIPELINE_INPUT_CONFIGS = gql(`
  query pipelineInputConfigs($venueId: Int!) {
    pipelineInputConfigs(venueId: $venueId) {
      id
      venueId
      feedTypeCode
      inputLabel
      category
    }
  }
`);
